import React, { useState, useEffect } from "react";
import "../styles/LevelInfoModal.css";
import { useTranslation } from "react-i18next";
import { FaTrophy, FaStar, FaGamepad, FaCoins, FaGift, FaPercent, FaChartLine, FaClipboardList } from "react-icons/fa";

import { getApiUrl } from "../utils/config";
const API_URL = getApiUrl();

const LevelInfoModal = ({ onClose }) => {
    const { t } = useTranslation();
    const [levelsData, setLevelsData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    // Загрузка данных об уровнях
    useEffect(() => {
        fetchLevelsData();
    }, []);

    const fetchLevelsData = async () => {
        try {
            const response = await fetch(`${API_URL}/api/levels`, {
                method: 'GET',
                credentials: 'include'
            });

            if (response.ok) {
                const data = await response.json();
                setLevelsData(data);
            } else {
                setError('Ошибка при загрузке информации об уровнях');
            }
        } catch (err) {
            console.error('Ошибка при получении уровней:', err);
            setError('Ошибка при загрузке информации об уровнях');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="level-info-modal-overlay">
                <div className="level-info-modal">
                    <div className="verification-loading">
                        <div className="loading-spinner"></div>
                        <p>Загрузка...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="level-info-modal-overlay">
                <div className="level-info-modal">
                    <button className="level-info-modal-close" onClick={onClose}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="12" fill="#23232e" />
                            <path d="M16 8L8 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                            <path d="M8 8L16 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                    </button>
                    <h3 className="level-info-modal-title">Ошибка</h3>
                    <p>{error}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="level-info-modal-overlay" onClick={(e) => {
            if (e.target === e.currentTarget) {
                onClose();
            }
        }}>
            <div className="level-info-modal" onClick={(e) => e.stopPropagation()}>
                <button className="level-info-modal-close" onClick={onClose}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="12" fill="#23232e" />
                        <path d="M16 8L8 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                        <path d="M8 8L16 16" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </button>

                <h3 className="level-info-modal-title">{t('Система уровней')}</h3>

                <div className="level-info-content">
                    {/* Общая информация */}
                    <div className="info-section">
                        <div className="info-section-header">
                            <FaTrophy className="info-icon" />
                            <h4>{t('Как работает система уровней')}</h4>
                        </div>
                        <p>
                            {t('Система уровней OnCaspin позволяет вам получать дополнительные преимущества за активную игру. ')}
                            {t('Чем больше вы играете, тем выше ваш уровень и больше привилегий вы получаете.')}
                        </p>
                    </div>

                    {/* Получение опыта */}
                    <div className="info-section">
                        <div className="info-section-header">
                            <FaStar className="info-icon" />
                            <h4>{t('Как получать очки опыта')}</h4>
                        </div>
                        <div className="experience-rules">
                            <div className="rule-item">
                                <FaGamepad className="rule-icon" />
                                <div className="rule-content">
                                    <h5>{t('Игра в слоты')}</h5>
                                    <p>{t('За каждые')} {levelsData?.experiencePointsPerDollar ? (1 / levelsData.experiencePointsPerDollar).toFixed(0) : '2'}$ {t('ставок вы получаете 1 очко опыта')}</p>
                                </div>
                            </div>
                            <div className="rule-item">
                                <FaCoins className="rule-icon" />
                                <div className="rule-content">
                                    <h5>{t('Минимальная ставка')}</h5>
                                    <p>{t('Ставки меньше 0.20$ не засчитываются для получения опыта')}</p>
                                </div>
                            </div>
                            <div className="rule-item">
                                <FaChartLine className="rule-icon" />
                                <div className="rule-content">
                                    <h5>{t('Накопление опыта')}</h5>
                                    <p>{t('Опыт накапливается автоматически и никогда не сгорает')}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Преимущества уровней */}
                    <div className="info-section">
                        <div className="info-section-header">
                            <FaGift className="info-icon" />
                            <h4>{t('Преимущества уровней')}</h4>
                        </div>
                        <div className="benefits-list">
                            <div className="benefit-item">
                                <FaPercent className="benefit-icon" />
                                <div className="benefit-content">
                                    <h5>{t('Увеличенный кешбек')}</h5>
                                    <p>{t('С каждым новым уровнем процент кешбека увеличивается от 5% до 16%')}</p>
                                </div>
                            </div>
                            <div className="benefit-item">
                                <FaTrophy className="benefit-icon" />
                                <div className="benefit-content">
                                    <h5>{t('Эксклюзивные бонусы')}</h5>
                                    <p>{t('Игроки высоких уровней получают доступ к специальным бонусам и акциям')}</p>
                                </div>
                            </div>
                            <div className="benefit-item">
                                <FaClipboardList className="benefit-icon" />
                                <div className="benefit-content">
                                    <h5>{t('Приоритетная поддержка')}</h5>
                                    <p>{t('VIP игроки получают приоритетное обслуживание в службе поддержки')}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Правила и ограничения */}
                    <div className="info-section">
                        <div className="info-section-header">
                            <FaClipboardList className="info-icon" />
                            <h4>{t('Правила и ограничения')}</h4>
                        </div>
                        <ul className="rules-list">
                            <li>{t('Очки опыта начисляются только за реальные ставки (не бонусные средства)')}</li>
                            <li>{t('Минимальная ставка для получения опыта составляет 0.20$')}</li>
                            <li>{t('Опыт начисляется в режиме реального времени после завершения раунда')}</li>
                            <li>{t('Уровень рассчитывается автоматически на основе накопленных очков опыта')}</li>
                            <li>{t('Кешбек начисляется еженедельно автоматически')}</li>
                            <li>{t('Администрация оставляет за собой право изменять правила системы уровней')}</li>
                            <li>{t('При подозрении в мошенничестве очки опыта могут быть аннулированы')}</li>
                        </ul>
                    </div>

                    {/* Таблица уровней */}
                    <div className="info-section">
                        <div className="info-section-header">
                            <FaChartLine className="info-icon" />
                            <h4>{t('Таблица уровней')}</h4>
                        </div>
                        <div className="levels-table">
                            <div className="table-header">
                                <span>{t('Уровень')}</span>
                                <span>{t('Название')}</span>
                                <span>{t('Очки опыта')}</span>
                                <span>{t('Кешбек')}</span>
                            </div>
                            {levelsData?.levels?.map((level, index) => (
                                <div key={level.level} className="table-row">
                                    <span className="level-number">{level.level}</span>
                                    <span className="level-name">
                                        {typeof level.icon === 'string' && level.icon.endsWith('.webp') ? (
                                            <img src={level.icon} alt={level.name} style={{ width: 50, height: 50, objectFit: 'contain', marginRight: 8, verticalAlign: 'middle' }} />
                                        ) : (
                                            level.icon
                                        )}
                                        {level.name}
                                    </span>
                                    <span className="level-points">
                                        {level.minPoints} - {level.maxPoints === 999999999 ? '∞' : level.maxPoints}
                                    </span>
                                    <span className="level-cashback">{level.cashbackPercent}%</span>
                                </div>
                            ))}
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
};

export default LevelInfoModal;
